import { type CloudinaryTransformConfig } from './CloudinaryImage';

// ─────────────────────────────────────────────────────────────────────────────

// NOTE: Screens that show the same image share one config, so an image downloaded
//       on one screen is reused on the others instead of downloaded in another size.

export const PRODUCT_CARD_IMAGE_CONFIG: CloudinaryTransformConfig = [
  { crop: 'crop', height: 0.7, width: 0.4 },
  { width: 365 },
];

export const PRODUCT_THUMBNAIL_IMAGE_CONFIG: CloudinaryTransformConfig = [
  { crop: 'crop', height: 0.6, width: 0.4 },
  { width: 120 },
];

export const ORDER_PRODUCT_IMAGE_CONFIG: CloudinaryTransformConfig = [
  { crop: 'crop', width: 0.95, height: 0.95 },
  { width: 230 },
];

export const ORDER_LINE_ITEM_IMAGE_CONFIG: CloudinaryTransformConfig = [
  { crop: 'crop', height: 0.66, width: 0.66 },
  { width: 343 },
];

export const INGREDIENT_IMAGE_CONFIG: CloudinaryTransformConfig = { crop: 'scale', width: 230 };
